import { c as _c } from "react/compiler-runtime";
import React from 'react';
import CtaButton from 'components/essentials/Cta/CtaButton';
import ProductListingLoadMoreButton from 'components/consumer/ProductListingPage/components/ProductListingLoadMoreButtons/ProductListingLoadMoreButton';
import useScreen from 'hooks/useScreen';
import useIsBrowser from 'hooks/useIsBrowser';
import useAdvancedSearchContext from '../../../hooks/useAdvancedSearchContext';
const AdvancedSearchLoadMoreButtons = t0 => {
  const $ = _c(13);
  const {
    onLoadMore,
    onShowAll,
    isLoading: t1,
    isLoadingAll: t2,
    showLoadMore: t3,
    enableShowAllButton: t4
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const isLoadingAll = t2 === undefined ? false : t2;
  const showLoadMore = t3 === undefined ? false : t3;
  const enableShowAllButton = t4 === undefined ? false : t4;
  const {
    pagesUrlParam
  } = useAdvancedSearchContext();
  const isBrowser = useIsBrowser();
  const {
    isTabletOrDesktop
  } = useScreen();
  if (!showLoadMore) {
    return null;
  }
  const showLoadAllButton = enableShowAllButton && isBrowser && pagesUrlParam >= 2;
  const isLoadMoreDisabled = isLoadingAll;
  const t5 = isLoadMoreDisabled ? _temp : onLoadMore;
  const t6 = isTabletOrDesktop && !isLoadMoreDisabled ? onShowAll : null;
  const t7 = isLoading || isLoadingAll;
  let t8;
  if ($[0] !== pagesUrlParam || $[1] !== t5 || $[2] !== t6 || $[3] !== t7) {
    t8 = <ProductListingLoadMoreButton clickCount={pagesUrlParam} onClick={t5} onLongPress={t6} isLoading={t7} />;
    $[0] = pagesUrlParam;
    $[1] = t5;
    $[2] = t6;
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== isLoading || $[6] !== isLoadingAll || $[7] !== onShowAll || $[8] !== showLoadAllButton) {
    t9 = showLoadAllButton && <div className="flex p-2"><CtaButton color="brand" onClick={onShowAll} isLoading={isLoadingAll} disabled={isLoading || isLoadingAll} styling="solid-button">Show All</CtaButton></div>;
    $[5] = isLoading;
    $[6] = isLoadingAll;
    $[7] = onShowAll;
    $[8] = showLoadAllButton;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = <div className="flex justify-center items-center gap-4 mt-8 mb-12">{t8}{t9}</div>;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
};
export default AdvancedSearchLoadMoreButtons;
function _temp() {}